import React from "react";
import { Chart } from "react-google-charts";
import moment from "moment";
import 'moment/locale/pt-br';
import { capitalizeFirstLetter } from 'services/structure/textUtils';
import { numberFormatter } from "services/structure/numberUtils";
import { isMobile } from "react-device-detect";
import { ChartDisableHover, ChartContainer, ChartSubtitle } from "./styles"


export default function CustomizedChart(props) {
  if (!(props.dados)) {
    return "";
  }

  let xAxis = props.dados.rotulos;
  if (props.xAxisType === "date") {
    const xAxisFormat = props.xAxisFormat ?? "DD/MM/YYYY";
    xAxis = xAxis.map( v => capitalizeFirstLetter(moment(v, "YYYY-MM-DD").locale('pt-br').format(xAxisFormat))); 
  }
  
  const vAxisFormat = props.vAxisFormat ?? 'decimal';
  const header = props.dados.dados.map( v => v.rotulo);
  const roles = Array(header.length * 2 + 1); // Line Labels, Values and Annotations
  roles[0] = { type: "string", label: "" }
  header.forEach( (v, i) => {
    roles[(i * 2) + 1] = { type: "number", label: v }
    roles[(i * 2) + 2] = { type: "string", role: "annotation" }
  });
  let values = xAxis.map((v, i) => {
    const itemVal = props.dados.dados.flatMap(v => { 
      let value = v.dados[i];
      let annotation = value;
      if (vAxisFormat === "percent") {
        annotation = numberFormatter.format(value) + '%';
        value /= 100; // percent formatter of chart multiply by 100
      }
      return [ value, annotation ]
    });
    return [v].concat(itemVal);
  }); 

  let qtValues = values.length;
  if (isMobile) {
    qtValues = 6
    values = values.slice(values.length - qtValues);
  }
  const subtitle = props.subtitle?.replace(/%d/g, qtValues);
  const dados = [roles].concat(values);

  return (
    <ChartContainer>
      <ChartDisableHover></ChartDisableHover>
      <Chart
        width={"100%"}
        height={"400px"}
        chartType="LineChart"
        loader={<div>Loading Chart</div>}
        data={dados}
        options={{
          chartArea: { left: 70, right: 30 },
          legend: { position: 'top', textStyle: { bold: true } },
          vAxis: { textPosition: 'left', gridlines: { count: 3 }, baselineColor: 'black', format: vAxisFormat },
          hAxis: { textStyle: { bold: true, fontSize: 12 } },
          pointSize: 5
        }}
        legend_toggle={false}
        legendToggle={false}
        rootProps={{ "data-testid": "4" }}
      />
      <ChartSubtitle>* {subtitle}</ChartSubtitle>
    </ChartContainer>
  );
}
